import { WidgetsByStandard } from '@atlas-metrics/microsite-types';

import { SubNavigationSectionProps } from '@/components/SubNavigation/SubNavigation';

export const transformWidgetToSubNavigationData = (
  data: WidgetsByStandard[] | null | undefined
): SubNavigationSectionProps[] => {
  return (data ?? []).flatMap(({ categories }) =>
    categories.map(({ name, themes }) => ({
      title: name,
      items: themes.map(({ id, name }) => ({
        id,
        label: name,
      })),
    }))
  );
};
